import { applianceType } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLC extends LegrandModule {
    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }
}
